import { render } from "./ReportCriterionAutocomplete.vue?vue&type=template&id=2b325a4d&scoped=true"
import script from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"
export * from "./ReportCriterionAutocomplete.vue?vue&type=script&lang=js"

import "./ReportCriterionAutocomplete.vue?vue&type=style&index=0&id=2b325a4d&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b325a4d"]])

export default __exports__